export const COMPARATOR_FAQ_CONTENT = [
  {
    question: 'How to compare cars on Edmunds?',
    answer: `Check out Edmunds' Car Comparison tool. It's driven by our extensive vehicle data that allow you to compare up to four vehicles at a time across criteria like price, features, fuel economy, trim levels, and options.`,
  },
  {
    question: 'Is there a website where I can compare cars?',
    answer: `You can compare cars head-to-head with Edmunds' Car Comparison tool. It's driven by our exclusive vehicle database and allows you to compare up to four vehicles at a time.`,
  },
  {
    question: `Is there a website that allows you to compare 2 cars to see which one you're better off with?`,
    answer:
      'At Edmunds you can compare 4 vehicles at a time across criteria like pricing, features, mpg, trim level, and options.',
  },
  {
    question: 'Help with comparing cars?',
    answer: `Compare cars head-to-head with Edmunds' Car Comparison tool.It's driven by our extensive vehicle database and allows you to compare prices, features, mpg, and options on up to four vehicles at a time.`,
  },
];
